export default __webpack_public_path__ + "assets/images/aa7b443a1c7d385621ce447ec52cc9af.svg";